<template>
    <ListenerPlayingDetails v-if="isListenerMobile" />
    <PlayingDetails v-else />
</template>

<script>
import PlayingDetails from './PlayingDetails.vue'
import ListenerPlayingDetails from './ListenerPlayingDetails.vue'

export default {
    name: 'PlayingDetailsEntry',
    components: {
        PlayingDetails,
        ListenerPlayingDetails
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
